module.exports = __webpack_public_path__ + "assets/images/boundaries/keys-four-new-smc/key-4-2015.svg?v=75a66124";